import React from "react";

export const Loading = () => {
    return (
        <>
            <section className="grid justify-center h-screen bg-background-101">
                <div className="text-4xl text-light-101">
                    Loading...
                </div>
            </section>
        </>
    );
};
